<template>
  <div class="editor-slider__card-wrapper">
    <div class="editor-slider__content-wrapper">
      <img v-lazy-load :src="imageSrc" :alt="description" />
      <div class="editor-slider__card-title">{{ description }}</div>
      <div v-if="source" class="editor-slider__card-source">
        Источник: <span>{{ source }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  imageSrc: { type: String, required: true },
  source: { type: String, default: '' },
  description: { type: String, default: '' },
});
</script>
